import http from './http'

const planoService = {
  getAll: page => http.get(`/plano?page=${page}`).then(result => result.data),
  getById: id => http.get(`/plano/${id}`).then(result => result.data.data),
  getByEmpresa: empresa => http.get(`/planoempresa/${empresa}`).then(result => result.data.data),
  getByNome: (str, empresa) => http.get(`/planodescr/${str}/${empresa}`).then(result => result.data),
  getByTipo: () => http.get(`/planotipo`).then(result => result.data),
  delete: id => http.delete(`/planodelete/${id}`).then(result => result.data.data),
  getByLista: (empresa) => http.get(`/planolista/${empresa}`).then(result => result.data),
  savePost: data => http({
    method: 'post',
    url: `/plano`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/plano/${data.id}`,
    data
  }).then(result => result.data.data)
}

export default planoService
